import React, { useState } from "react";
import {
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
} from "@mui/material";
import Button from "components/button/Button";
import LoginDialog from "components/card/LoginDialog";
import VerifyEmailDialog from "components/card/VerifyEmailDialog";

const SurveysButton = ({
  survey,
  onChange,
  currentUser,
  isDisabled,
  disabledText = "Սպասում․․․",
}) => {
  const [isOpenChoicesModal, setIsOpenChoicesModal] = useState(false);
  const [isOpen, setIsOpen] = useState(false);
  const [isOpenVerifyEmailDialog, setIsOpenVerifyEmailDialog] = useState(false);

  return (
    <div className="flex justify-end items-center cursor-pointer">
      <Button
        className="text-xs tracking-widest"
        variant={isDisabled ? "secondary" : "primary"}
        onClick={() => {
          if (!currentUser) {
            setIsOpen(true);
          }
          if (currentUser && !currentUser.emailVerified) {
            currentUser.providerData?.[0].providerId !== "facebook.com" &&
              setIsOpenVerifyEmailDialog(true);
          }
          if (
            currentUser &&
            (currentUser.emailVerified ||
              currentUser.providerData?.[0].providerId === "facebook.com")
          ) {
            !isDisabled && setIsOpenChoicesModal(true);
          }
        }}
      >
        <span className="opacity-90">
          {isDisabled ? disabledText : "Կանխատեսել"}
        </span>
      </Button>

      <Dialog
        open={isOpenChoicesModal}
        onClose={() => setIsOpenChoicesModal(false)}
        PaperProps={{
          style: {
            borderRadius: 24,
            padding: 8,
            fontFamily: "Noto Sans Armenian",
          },
        }}
      >
        <DialogTitle
          sx={{
            fontWeight: "bold",
            fontSize: "1.1rem",
            color: "#0f172a",
          }}
        >
          {survey.title}
        </DialogTitle>
        <DialogContent dividers sx={{ borderColor: "#f1f5f9" }}>
          <div className="flex flex-col gap-4 py-2">
            <span className="text-slate-600 dark:text-slate-300 text-sm leading-relaxed">
              {survey.description}
            </span>
            <div className="flex flex-wrap gap-3 mt-2">
              {survey.choices?.map((choice) => {
                return (
                  <Button
                    key={choice.id}
                    variant={
                      choice.id === survey.votes?.[currentUser?.uid]
                        ? "primary"
                        : "secondary"
                    }
                    className="w-full sm:w-fit !rounded-full !px-5 !py-2"
                    onClick={() => {
                      if (!currentUser) {
                        setIsOpen(true);
                      }
                      if (currentUser && !currentUser.emailVerified) {
                        currentUser.providerData?.[0].providerId !==
                          "facebook.com" && setIsOpenVerifyEmailDialog(true);
                      }
                      if (
                        currentUser &&
                        (currentUser.emailVerified ||
                          currentUser.providerData?.[0].providerId ===
                            "facebook.com")
                      ) {
                        !isDisabled && onChange(choice.id);
                        setIsOpenChoicesModal(false);
                      }
                    }}
                  >
                    {choice.value}
                  </Button>
                );
              })}
            </div>
          </div>
        </DialogContent>
        <DialogActions sx={{ padding: 2 }}>
          <Button onClick={() => setIsOpenChoicesModal(false)} variant="danger">
            Փակել
          </Button>
        </DialogActions>
      </Dialog>
      <LoginDialog isOpen={isOpen} handleClose={() => setIsOpen(false)} />
      <VerifyEmailDialog
        isOpen={isOpenVerifyEmailDialog}
        handleClose={() => setIsOpenVerifyEmailDialog(false)}
      />
    </div>
  );
};

export default SurveysButton;
